import Vue from "vue";
import VueI18n from "vue-i18n";
import enLocale from "./i18n-en";
import deLocale from "./i18n-de";
import frLocale from "./i18n-fr";
import itLocale from "./i18n-it";

// vee validation
import validationEn from "vee-validate/dist/locale/en";
import validationDe from "vee-validate/dist/locale/de";
import validationIt from "vee-validate/dist/locale/it";
import validationFr from "vee-validate/dist/locale/fr";

Vue.use(VueI18n);

const i18nData = {
  en: {
    ...enLocale,
    validations: {
      ...validationEn,
      messages: {
        ...validationEn.messages,
        "phone-validation": "The {_field_} field must be a valid phone number",
      },
    },
  },
  de: {
    ...deLocale,
    validations: validationDe,
  },
  fr: {
    ...frLocale,
    validations: validationFr,
  },
  it: {
    ...itLocale,
    validations: validationIt,
  },
};

export default new VueI18n({
  locale: localStorage.getItem("rnd-language") || "de", // set default locale
  messages: i18nData,
});



// WEBPACK FOOTER //
// ./src/i18n/i18n.js